import template from './finance-card.pug';

export const FinanceCardComponent = {
  template,
  bindings: {
    record: '<?',
    recordId: '<?',
    onRemove: '&?',
  },
  controller: class FinanceCardComponent {
    constructor(Finance, $log, $async, $window) {
      'ngInject';

      this.$log = $log;
      this.Finance = Finance;
      this.$window = $window;
      this.getRecord = $async(this.getRecord.bind(this));
      this.getFullRecord = $async(this.getFullRecord.bind(this));
      this.open = $async(this.open.bind(this));
      this.currency = $window.CURRENCY;
    }

    $onInit() {
      if (this.recordId) this.getRecord();
    }

    async getFullRecord() {
      if (this.fullRecord) return;

      try {
        this.fullRecord = await this.Finance.find(this.record.id);
      } catch (e) {
        this.fullRecord = this.record;
        this.$log.error(e);
      }
    }

    async open() {
      try {
        const resp = await this.Finance.previewModal(this.fullRecord);
      } catch (e) {
        this.$log.error(e);
      }
    }

    async getRecord() {
      try {
        this.record = await this.Finance.cardInfo(this.recordId);
      } catch (e) {
        this.$log.error(e);
      }
    }

    removeEnabled() {
      return typeof(this.onRemove) === 'function';
    }

    remove(record) {
      this.onRemove({
        $event: { record }
      });
    }

  }
};
